export default __webpack_public_path__ + "static/hero-image-3-09774b666918838bd75dae813b2ba321.jpeg";